import { Component, Input } from '@angular/core';
import {  Router  } from '@angular/router';
import { GaService } from "../../common/services/ga.service";

@Component({
  selector: 'mobile-search-results',
  templateUrl: './mobile-search-results.component.html',
  styleUrls: ['./mobile-search-results.component.css']
})
export class MobileSearchResultsComponent  {

  @Input() filterResultsBy;
  @Input() searchResult;
  @Input() haveResults;
  @Input() emptySearch;

  constructor(private router: Router,
              private gaService: GaService) {}

  navigateToProfile(id, type){
    if(type === "system"){
      this.router.navigate(['/systemProfile', id])
      this.addToGA('','system','')
    } else if (type === 'person'){
      this.router.navigate(['/hospitalProfile', id])
      this.addToGA('','hospital','')
    }
  }

  navigateToPersonProfile(facilityObj){
    if(facilityObj.orgDisplayName){
      this.router.navigate(['/hospitalProfile', facilityObj.id])
      this.addToGA('','person','')
    } else if (facilityObj.systemDisplayName){
      this.router.navigate(['/systemProfile', facilityObj.id])
      this.addToGA('','person','')
    }
  }

  addToGA(profileName,type,isMember){
    this.gaService.addSearchResultClick(profileName,type,isMember);
  }

  addToGAPerson(profileName,type){
    this.gaService.addPersonSearchResultClick(profileName,type);
  }

}



// WEBPACK FOOTER //
// ./src/app/search/mobile-search-results/mobile-search-results.component.ts